import cloneDeep from 'lodash/cloneDeep'
import {
  ConfigService
} from '@/services/api'

import ItemTemplate from '@/components/Maps/InfoTextTemplates/Item'

function flattenObject(obj) {
  const toReturn = {}

  for (const i in obj) {
    if (!obj.hasOwnProperty(i)) continue

    if ((typeof obj[i]) === 'object' && obj[i] !== null) {
      const flatObject = flattenObject(obj[i])
      for (const x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue

        toReturn[i + '.' + x] = flatObject[x]
      }
    } else {
      toReturn[i] = obj[i]
    }
  }
  return toReturn
}

function unflattenObject(obj) {
  const result = {}
  for (const i in obj) {
    const keys = i.split('.')
    keys.reduce(function (r, e, j) {
      return r[e] || (r[e] = Number.isNaN(Number(keys[j + 1])) ? (keys.length - 1 === j ? obj[i] : {}) : [])
    }, result)
  }
  return result
}

function renameKeys(obj, fn) {
  if (typeof fn !== 'function') {
    return obj
  }

  const keys = Object.keys(obj)
  const result = {}

  for (let key of keys) {
    const val = obj[key]
    const str = fn(key, val)
    if (typeof str === 'string' && str !== '') {
      key = str
    }
    result[key] = val
  }
  return result
}

function setFilters(filters, currentFilters = {}) {
  filters.columns.forEach(column => {
    column.filters.forEach(filter => {
      if (filter.name) {
        currentFilters = { ...currentFilters, [filter.name]: filter.value }
      } else {
        return setFilters(filter, currentFilters)
      }
    })
  })
  return currentFilters
}

export default {
  state: {
    ecosystem: {
      product: 'gcm2',
      siteName: 'Moova',
      logo: '/static/img/moova.svg',
      logoLogin: '/static/img/moova-blue.svg',
      theme: 'moova',
      helpUrl: 'http://ayuda.moova.io/',
      googleRegister: true,
      terms: 'https://moova.io/terminos-y-condiciones/',
      privacy: 'https://moova.io/politica-de-privacidad/'
    },
    logo: null,
    logoPinned: null,
    ecosystemCountries: [],
    frontConfig: {},
    ecosystemConfig: {
      links: {
        help: '',
        terms: '',
        privacy: ''
      },
      googleRegister: false,
      extraCheckpoints: {
        beforePickup: false,
        beforeDelivery: false
      }
    },
    ecosystemModules: {
      couriers: {
        self: true
      },
      shippings: {
        self: true,
        shared: true
      },
      tours: {
        self: true,
        shared: true
      },
      items: {
        self: false,
        label: null,
        geolocalizableBy: null,
        templateInfoText: ItemTemplate.templateInfoText,
        icon: ItemTemplate.icon
      },
      geofences: false,
      companies: true,
      transactions: true,
      stores: {
        self: false,
        label: null
      }
    },
    ecosystemPlugins: null,
    ecosystemMaps: null,
    models: {},
    dataTransformers: {},
    quickFiltersSetup: {},
    plainQuickFiltersSetup: {},
    mapFiltersSetup: {},
    appRoles: [],
    vehicleTypes: [],
    shippingSizes: [],
    shippingTypes: [],
    shippingTypesShared: [],
    shippingSettings: [],
    platforms: [],
    receiverTypes: [],
    shippingStatusReasons: {},
    tobereturnedStatusReasons: [],
    geoTypes: [],
    spinner: false,
    vehicleTypeGroupVehicleTypes: [],
    commodityVarieties: []
  },
  getters: {
    ecosystem: state => {
      return state.ecosystem
    },
    logo: state => {
      return state.logo
    },
    logoPinned: state => {
      return state.logoPinned
    },
    ecosystemCountries: state => {
      return state.ecosystemCountries
    },
    frontConfig: state => {
      return state.frontConfig
    },
    ecosystemConfig: state => {
      return state.ecosystemConfig
    },
    ecosystemModules: state => {
      return state.ecosystemModules
    },
    ecosystemPlugins: state => {
      return state.ecosystemPlugins
    },
    ecosystemMaps: state => {
      return state.ecosystemMaps
    },
    models: state => {
      return state.models
    },
    dataTransformers: state => {
      return state.dataTransformers
    },
    quickFiltersSetup: state => {
      return state.quickFiltersSetup
    },
    plainQuickFiltersSetup: state => {
      return state.plainQuickFiltersSetup
    },
    mapFiltersSetup: state => {
      return state.mapFiltersSetup
    },
    appRoles: state => {
      return state.appRoles
    },
    vehicleTypes: state => {
      return state.vehicleTypes
    },
    vehicleTypesSelect: state => {
      return state.vehicleTypes.map((item) => {
        return {
          value: item.id,
          text: item.name
        }
      })
    },
    shippingSizes: state => {
      return state.shippingSizes
    },
    shippingTypes: state => {
      return state.shippingTypes
    },
    shippingTypesShared: state => {
      return state.shippingTypesShared
    },
    shippingSettings: state => {
      return state.shippingSettings
    },
    platforms: state => {
      return state.platforms
    },
    receiverTypes: state => {
      return state.receiverTypes
    },
    shippingStatusReasons: state => {
      return state.shippingStatusReasons
    },
    tobereturnedStatusReasons: state => {
      return state.tobereturnedStatusReasons
    },
    geoTypes: state => {
      return state.geoTypes
    },
    spinner: state => {
      return state.spinner
    },
    vehicleTypeGroupVehicleTypes: state => {
      return state.vehicleTypeGroupVehicleTypes
    },
    commodityVarieties: state => {
      return state.commodityVarieties
    }
  },
  mutations: {
    checkEcosystem: (state, payload) => {
      console.log(ConfigService.getEcosystems())
    },
    setEcosystem: (state, payload) => {
      console.log(payload)
      if (payload) {
        document.documentElement.className = payload.theme
        state.ecosystem = payload
      }
    },
    setEcosystemCountries: (state, payload) => {
      console.log(state.eid)
      console.log(payload)
      return ConfigService.getCountries(payload)
        .then(response => {
          state.ecosystemCountries = response.body.data
          window.countries = response.body.data
        })
    },
    setFrontConfig: (state, payload) => {
      if (payload) {
        state.frontConfig = payload
      }
    },
    setEcosystemModules: (state, payload) => {
      console.log(state.eid)
      console.log(payload)
      return ConfigService.getEcosystem(payload)
        .then(response => {
          console.log(response.body.front_config)
          if (response.body.front_config?.modules) {
            state.ecosystemModules = { ...state.ecosystemModules, ...response.body.front_config.modules, remote: true }
          } else {
            state.ecosystemModules = { ...state.ecosystemModules, remote: true }
          }
          if (response.body.front_config?.general) {
            state.ecosystemConfig = { ...response.body.front_config.general, ...{ remote: true } }
          }
          if (response.body.front_config?.plugins) {
            state.ecosystemPlugins = { ...response.body.front_config.plugins, ...{ remote: true } }
          }
          if (response.body.front_config?.maps) {
            // TODO: refactor this :/
            response.body.front_config.maps.providers = response.body.front_config.maps.providers.map(x => {
              const provider = flattenObject(x)
              for (const key in provider) {
                if (provider.hasOwnProperty(key)) {
                  if (typeof provider[key] === 'string') {
                    const matches = provider[key].match(/{{([^}]+)}}/g)
                    if (Array.isArray(matches) && matches.length > 0) {
                      for (const keyToReplace of matches) {
                        provider[key] = provider[key].replaceAll(/{{([^}]+)}}/g, provider[keyToReplace.replaceAll('{{', '').replaceAll('}}', '')])
                      }
                    }
                  }
                }
              }
              return unflattenObject(provider)
            })
            state.ecosystemMaps = { ...response.body.front_config.maps, ...{ remote: true } }
          }
          if (response.body.front_config?.ecosystem) {
            state.ecosystem = { ...state.ecosystem, ...response.body.front_config.ecosystem }
            state.logo = state.ecosystem.logo || null
            state.logoPinned = state.ecosystem.logoPinned || null
          }
        })
    },
    setModels: (state, payload) => {
      console.log('models', cloneDeep(payload))
      if (payload) {
        state.models = renameKeys(payload, function (key, val) {
          return key.replaceAll('Model', '')
        })
      }
    },
    setDataTransformers: (state, payload) => {
      if (payload) {
        state.dataTransformers = payload
      }
    },
    setQuickFilters: (state, payload) => {
      console.log('quickFiltersSetup', cloneDeep(payload))
      if (payload) {
        // state.quickFiltersSetup = payload
        state.quickFiltersSetup = renameKeys(payload, function (key, val) {
          return key.replaceAll('QuickFilters', '')
        })
        for (const key in state.quickFiltersSetup) {
          if (Object.hasOwn(state.quickFiltersSetup, key)) {
            const element = state.quickFiltersSetup[key]
            state.plainQuickFiltersSetup[key] = setFilters(element.filters)
          }
        }
        console.log(state.plainQuickFiltersSetup)
      }
    },
    setMapFilters: (state, payload) => {
      if (payload) {
        state.mapFiltersSetup = payload
      }
    },
    setAppRoles: async (state, payload) => {
      return await ConfigService.getRoles(payload)
        .then(response => {
          const appRoles = response.body.data.map((item) => {
            if (window.allowedRoles.map(x => x.role).includes(item.name)) {
              return {
                value: item.id,
                text: item.name
              }
            }
          }).filter(Boolean)
          setTimeout(() => {
            state.appRoles = appRoles.map(x => {
              if (state.ecosystemModules.remote && !state.ecosystemModules.carriers && x.text === 'gcm-admin') {
                return null
              } else {
                return x
              }
            }).filter(Boolean)
            window.allowedRoles = window.allowedRoles.filter(x => state.appRoles.map(y => y.text).includes(x.role))
          }, 1000)
        })
    },
    setVehicleTypes: (state, payload) => {
      return ConfigService.getVehicleTypes(payload)
        .then(response => {
          state.vehicleTypes = response.body.data
        })
    },
    setShippingSizes: (state, payload) => {
      return ConfigService.getShippingSizes(payload)
        .then(response => {
          state.shippingSizes = response.body.data
        })
    },
    setShippingTypes: (state, payload) => {
      return ConfigService.getShippingTypes(payload)
        .then(response => {
          state.shippingTypesShared = response.body.data.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          state.shippingTypes = response.body.data.map((item) => {
            if (window.allowedShippingTypes.includes(item.name)) {
              return {
                value: item.id,
                text: item.name
              }
            }
          }).filter(Boolean)
        })
    },
    setShippingSettings: (state, payload) => {
      return ConfigService.getShippingSettings(payload)
        .then(response => {
          state.shippingSettings = response.body.data.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          }).filter(Boolean)
        })
    },
    setPlatforms: (state, payload) => {
      return ConfigService.getPlatforms(payload)
        .then(response => {
          state.platforms = response.body.data
        })
    },
    setReceiverTypes: (state, payload) => {
      return ConfigService.getReceiverTypes(payload)
        .then(response => {
          state.receiverTypes = response.body.data
        })
    },
    setShippingStatusReasons: (state, payload) => {
      return ConfigService.getShippingStatusReasons(payload)
        .then(response => {
          state.shippingStatusReasons = response.body.data
          for (const reason of response.body.data) {
            if (!state.shippingStatusReasons[reason.event]) {
              state.shippingStatusReasons[reason.event] = []
            }
            // reset the shipping_status_reasons events to match shipping statuses
            if (reason.event === 'PICKEDUP') {
              reason.event = 'CONFIRMED'
            } else if (reason.event === 'DELIVERED') {
              state.tobereturnedStatusReasons.push({ name: reason.name, description: reason.description, reason_id: reason.id })
              reason.event = 'INTRANSIT'
            }
            state.shippingStatusReasons[reason.event].push({ name: reason.name, description: reason.description, reason_id: reason.id })
          }
        })
    },
    setGeoTypes: (state, payload) => {
      return ConfigService.getGeoTypes(payload)
        .then(response => {
          state.geoTypes = response.body.data
        })
    },
    showSpinner: (state) => {
      state.spinner = true
    },
    hideSpinner: (state) => {
      state.spinner = false
    },
    setVehicleTypeGroupVehicleTypes: (state, payload) => {
      state.vehicleTypeGroupVehicleTypes = payload
    },
    setCommodityVarieties: (state, payload) => {
      state.commodityVarieties = payload
    }
  },
  actions: {
    checkEcosystem: ({ commit }, payload) => {
      commit('checkEcosystem', payload)
    },
    setEcosystem: ({ commit }, payload) => {
      commit('setEcosystem', payload)
    },
    setEcosystemCountries: ({ commit }, payload) => {
      commit('setEcosystemCountries', payload)
    },
    setFrontConfig: ({ commit }, payload) => {
      commit('setFrontConfig', payload)
    },
    setEcosystemModules: ({ commit }, payload) => {
      commit('setEcosystemModules', payload)
    },
    setModels: ({ commit }, payload) => {
      commit('setModels', payload)
    },
    setDataTransformers: ({ commit }, payload) => {
      commit('setDataTransformers', payload)
    },
    setQuickFilters: ({ commit }, payload) => {
      commit('setQuickFilters', payload)
    },
    setMapFilters: ({ commit }, payload) => {
      commit('setMapFilters', payload)
    },
    setAppRoles: ({ commit }, payload) => {
      commit('setAppRoles', payload)
    },
    setVehicleTypes: ({ commit }, payload) => {
      commit('setVehicleTypes', payload)
    },
    setShippingSizes: ({ commit }, payload) => {
      commit('setShippingSizes', payload)
    },
    setShippingTypes: ({ commit }, payload) => {
      commit('setShippingTypes', payload)
    },
    setShippingSettings: ({ commit }, payload) => {
      commit('setShippingSettings', payload)
    },
    setPlatforms: ({ commit }, payload) => {
      commit('setPlatforms', payload)
    },
    setReceiverTypes: ({ commit }, payload) => {
      commit('setReceiverTypes', payload)
    },
    setShippingStatusReasons: ({ commit }, payload) => {
      commit('setShippingStatusReasons', payload)
    },
    setGeoTypes: ({ commit }, payload) => {
      commit('setGeoTypes', payload)
    },
    showSpinner: ({ commit }) => {
      commit('showSpinner')
    },
    hideSpinner: ({ commit }) => {
      commit('hideSpinner')
    },
    setVehicleTypeGroupVehicleTypes: ({ commit }, payload) => {
      commit('setVehicleTypeGroupVehicleTypes', payload)
    },
    setCommodityVarieties: ({ commit }, payload) => {
      commit('setCommodityVarieties', payload)
    }
  }
}
